import {useMemo} from "react"
import {getCurrentUser} from "../../api/auth"
import Api from "../../api/graphql/Api"
import {SubscribedActivity} from "../../models"
import MessageService from "../../services/MessageService"

const SubscribedActivityApi = new Api("SubscribedActivity")

const MessageProvider = ({children}) => {
    const {
        messages,
        unreadMessages
    } = useMemo(async () => {
            return await getCurrentUser()
                .then(({user}) => {
                    if (user?.username) {
                        return SubscribedActivityApi
                            .runCustomQuery("getNotificationsForUser", {userId: user?.username})
                    } else {
                        return []
                    }
                })
                .then((retrievedNotifications: SubscribedActivity[]) => {
                    return {
                        messages: retrievedNotifications
                            .filter((notification) => {
                                return notification?._deleted !== true
                            }),
                        unreadMessages: retrievedNotifications
                            .filter((notification) => {
                                return notification?._deleted !== true && notification?.read === false
                            })
                    }
                })
        }, []
    )

    return <MessageService
        messages={ messages ?? [] }
        unreadMessages={ unreadMessages ?? [] }
    >

        { children }
    </MessageService>
}

export default MessageProvider
